module.exports = __webpack_public_path__ + "92844509de2d53fe54618e6d891fa6ba.pdf";